export default "__VITE_ASSET__a21a1f6f__"